import { render } from "./Top10.vue?vue&type=template&id=40d33227"
import script from "./Top10.vue?vue&type=script&lang=js"
export * from "./Top10.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/player/Top10.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40d33227"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40d33227', __exports__)) {
    api.reload('40d33227', __exports__)
  }
  
  module.hot.accept("./Top10.vue?vue&type=template&id=40d33227", () => {
    api.rerender('40d33227', render)
  })

}


export default __exports__